/* node_modules */
import React from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import Loading from '~/components/Loading';
import FormattedMessage from '~/components/common/FormattedMessage';

import { deleteImage } from '~/modules/gallery';

import { visibilityFilter } from '~/helpers/data';

import ImagePreview from '../ImagePreview';
/* style imports */
import styles from './ImageSet.scss';


const ImageSet = ({
  images: items,
  currentUser,
  adultToggleState,
  onDelete,
  noUsernames,
  isLoading,
  /**
   * class to be applied to images
   */
  imageClassName = '',
  className = '',
}: {
  images: GalleryImage[];
  currentUser?: User;
  adultToggleState?: string;
  onDelete?: () => void;
  noUsernames?: boolean;
  isLoading?: boolean;
  imageClassName?: string;
  className?: string;
}) => {
  // const {
  //   images: items,
  //   currentUser,
  //   adultToggleState,
  //   onDelete,
  //   tagCheck,
  //   pass,
  //   noUsernames,
  //   isLoading,
  // } = props;

  const dispatch = useDispatch();
  const confirmDeletion = (id, e) => {
    e.preventDefault();
    e.stopPropagation();

    if (window.confirm('Delete this image?')) {
      dispatch(deleteImage(id)).then(() => {
        onDelete && onDelete();
      });
    }

    return false;
  };

  if (isLoading && !(images.length > 0))
    return <Loading message="Loading images..." />;

  const images = visibilityFilter(items, adultToggleState);
  const imagesHidden = images.length !== items.length;

  return (
    <>
      {imagesHidden && (
        <div className={styles.ImageSet__Warning}>
          <span role="img" className="ion-android-warning" /> Some images hidden
          by your content filter setting
        </div>
      )}
      <div className={classNames(styles.ImageSet, className)}>
        {images.length > 0 ? (
          images.map((image) => (
            <ImagePreview
              {...image}
              key={`img:${image.id}`}
              deleteImage={
                currentUser &&
                (currentUser.role === 'admin' ||
                  image.user.username === currentUser.username)
                  ? confirmDeletion
                  : false
              }
              isBlacklisted={false}
              noUsernames={noUsernames}
              className={imageClassName}
            />
          ))
        ) : (
          <FormattedMessage
            id="ImageSet_Empty"
            defaultMessage="There doesn't seem to be anything here."
          />
        )}
      </div>
    </>
  );
};

export default ImageSet;
